import React from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { BackButton, Box, Center, ZStack } from '~/commonComponents';

export const HeaderSection: React.FC = () => {
  return (
    <>
      <Box position="relative" marginBottom={32} marginTop={40}>
        <Center>
          <ZStack left={8}>
            <BackButton />
          </ZStack>

          <Typography as="span" size="heading_2" bold textAlign="center">
            How It Works
          </Typography>
        </Center>
      </Box>

      <Center marginBottom={32} maxWidth={640}>
        <Typography as="span" size="body_large" textAlign="center" color={colors.neutral[500]}>
          GoTu connects you with licensed, verified dental professionals, on your schedule and at
          your rate. You post the shift, approve the day, and we handle the rest. It&apos;s that
          simple.
        </Typography>
      </Center>
    </>
  );
};
